import React, { ReactElement, useState } from "react";
import { useTranslate } from "@obsbot/remo-i18n";
import { Select, SelectProps } from "antd";
import { constants } from "remo-types";
import { CustomModal } from "../CustomModal";
import DropdownSVG from "../icons/Dropdown.svg";
import "./index.less";

export interface BindRelationShipProps {
    initialValue?: constants.RelationShip;
    action: string;
    visible: boolean;
    onOk: (relationship: constants.RelationShip) => void;
    setVisible: (flag: boolean) => void;
}

export const BindRelationshipModal: React.FC<BindRelationShipProps> = ({
    action,
    setVisible,
    visible,
    onOk,
}): ReactElement => {
    const t = useTranslate();
    const relationshipGroup: SelectProps["options"] = Object.values(constants.RelationShip).map(
        value => ({
            label: t(`relationship.${value}`),
            value: value,
            title: "",
        }),
    );
    // 记录当前亲密关系
    const [relationship, setRelationship] = useState<constants.RelationShip>(
        constants.RelationShip.Lovers,
    );
    return (
        <CustomModal
            className="bindRelationshipModal"
            destroyOnHidden={true}
            footer={
                <div
                    className="modal-button-item"
                    onClick={() => {
                        // setRelationship(constants.RelationShip.Lovers);
                        onOk && onOk(relationship);
                    }}
                >
                    {t("confirm")}
                </div>
            }
            open={visible}
            renderHeader={t("chat.relationship-" + action)}
            setVisible={setVisible}
            width={392}
            onClickClose={() => setRelationship(constants.RelationShip.Lovers)}
        >
            <Select
                defaultValue={constants.RelationShip.Lovers}
                options={relationshipGroup}
                rootClassName="BindRelationshipSelector"
                showSearch={false}
                style={{ width: "100%" }}
                suffixIcon={
                    <div className="dropdownIcon">
                        <img src={DropdownSVG} />
                    </div>
                }
                virtual={false}
                onChange={value => setRelationship(value)}
            />
        </CustomModal>
    );
};
